module.exports = __webpack_public_path__ + "img/qr-icon.da5d5533.png";